const BASE = process.env.REACT_APP_API_URL ?? "http://localhost:5000/api";

const authHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

/** Fetch all panels the logged-in jury member belongs to (idea_selection + round) */
export async function fetchMyPanels(token: string) {
  const res = await fetch(`${BASE}/panels/my-panel`, { headers: authHeaders(token) });
  if (!res.ok) throw new Error("No panel assignment found");
  return res.json() as Promise<any[]>;
}

/** @deprecated use fetchMyPanels */
export async function fetchMyPanel(token: string) {
  const panels = await fetchMyPanels(token);
  return panels[0];
}

/** Fetch final submissions for jury review — all ideas scoped to a hackathon */
export async function fetchJuryIdeas(token: string, hackathonId: string) {
  const res = await fetch(`${BASE}/ideas?hackathonId=${hackathonId}&limit=100`, {
    headers: authHeaders(token),
    cache: "no-store",
  });
  const data = await res.json();
  return data.items ?? [];
}

/** Fetch all idea-selection decisions for a hackathon (to know what's already decided) */
export async function fetchIdeaSelections(token: string, hackathonId: string) {
  const res = await fetch(`${BASE}/idea-selections?hackathonId=${hackathonId}&limit=200`, {
    headers: authHeaders(token),
    cache: "no-store",
  });
  if (!res.ok) throw new Error("Failed to fetch idea selections");
  const data = await res.json();
  return data.items ?? [];
}

/** Submit a jury decision (select / reject) for an idea */
export async function submitIdeaDecision(
  token: string,
  payload: { ideaId: string; hackathonId: string; panelId: string; teamId: string; decision: "selected" | "rejected"; reason?: string; rating?: number }
) {
  const res = await fetch(`${BASE}/idea-selections`, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message ?? "Failed to submit decision");
  return data;
}
